export default {
	URLS_DOCS: {
        1: {
            url: "https://drive.google.com/file/d/1oKcpKkWNO3AWtlG2DCCREz0YtSXeBBFP",
            img: "examenpun.png"
        },
        2: {
            url: "https://drive.google.com/file/d/1n2_97EmDBRdDd3qsT5QgdUEBOX9LNHwy/view?usp=sharing",
            img: "examendan.png"
        },
        3: {
            url: "files/HOJA INSCRIPCION ACTIVIDAD NACIONAL.doc",
            img: "inscripcion.png"
        },
        4: {
            url: "https://drive.google.com/file/d/1jI3pMD_74KYoqqe5S_2douEjbvUAohPV/view?usp=sharing",
            img: "reglamentoarbitraje.png"
        },
        5: {
            url: "https://drive.google.com/file/d/1kE1ZBDjiy4tFMGVOyRBkB4fuMpupON5d/view?usp=sharing",
            img: "reglamentoarbitrajepoomsaes.png"
        },
        6: {
            url: "https://drive.google.com/file/d/1ShxHYttqTaeKF68vVqXCD6zlGT8n4vNI",
            img: "reglamentoadultopoomses.png"
        },
        7: {
            url: "https://drive.google.com/file/d/16SPpYkXe3xngXPzUEf2VUH1SLeOP6MRX",
            img: "reglamentoadultoexhibicion.png"
        },
        8: {
            url: "https://drive.google.com/file/d/1MzHHpGN-efWi5V1vu6g6XJ2bWiMxUWGp",
            img: "reglamentoinfantilexhibicion.png"
        },
        9: {
            url: "https://drive.google.com/open?id=1Ds0ZLkta6Gj7dL31e8Hdw_BjRtDmpsFx",
            img: "reglamentoinfantilpoomses.png"
        }
    }
}
